export const TEST_IDS = {
  nav: {
    root: "site-nav",
    home: "nav-home",
    profile: "nav-profile",
    career: "nav-career",
    goalkeepers: "nav-goalkeepers",
    methodology: "nav-methodology",
    education: "nav-education",
    references: "nav-references",
    contact: "nav-contact",
    langEs: "lang-es",
    langEn: "lang-en",
    cta: "nav-cta-contact",
    mobileMenu: "nav-mobile-toggle",
  },
  hero: {
    root: "hero-section",
    ctaCareer: "hero-cta-career",
    ctaContact: "hero-cta-contact",
  },
  impact: { root: "impact-section", stat: (i) => `impact-stat-${i}` },
  profile: { root: "profile-section" },
  career: { root: "career-section", card: (i) => `career-card-${i}` },
  goalkeepers: {
    root: "goalkeepers-section",
    filter: (k) => `gk-filter-${k}`,
    card: (i) => `gk-card-${i}`,
  },
  development: { root: "development-section", card: (i) => `dev-card-${i}` },
  methodology: { root: "methodology-section", pillar: (i) => `pillar-${i}` },
  process: { root: "process-section", step: (i) => `process-step-${i}` },
  education: { root: "education-section", item: (i) => `education-item-${i}` },
  references: { root: "references-section", card: (i) => `ref-card-${i}` },
  media: { root: "media-section" },
  contact: {
    root: "contact-section",
    email: "contact-email-btn",
    whatsapp: "contact-whatsapp-btn",
    cv: "contact-cv-btn",
    form: "contact-form",
    name: "contact-input-name",
    org: "contact-input-org",
    position: "contact-input-position",
    formEmail: "contact-input-email",
    phone: "contact-input-phone",
    message: "contact-input-message",
    submit: "contact-form-submit",
    website: "contact-input-website",
  },
  admin: {
    loginForm: "admin-login-form",
    email: "admin-login-email",
    password: "admin-login-password",
    submit: "admin-login-submit",
    logout: "admin-logout",
    dashboard: "admin-dashboard",
  },
};
